import {ieFix} from './utils/ie-fix';
import {iosVhFix} from './utils/ios-vh-fix';

import {initModals} from './modules/init-modals';
import {menuTabs} from './modules/menu-tab';
import {mobileMenu} from './modules/mobile-menu';
import {siteSearch} from './modules/site-search';
import {cssVariables} from './modules/css-variables';
import {donateButtons} from './modules/donate-buttons';
import {donateFaq} from './modules/donate-faq';
import setInputMask from './modules/tel-mask';
import {readMore} from './modules/read-more';
import {receptionPointsTabs} from './modules/reception-points-tabs';
import {viewAll} from './modules/view-all';
import {readAll} from './modules/read-all';
import {specialSlider} from './modules/special-slider';
import {helpNowSlider} from './modules/help-now-slider';
import {promoSlider} from './modules/promo-slider';
import {bookmarkTransition} from './modules/bookmark-transition';
import {createCustomSelect} from './modules/create-custom-select';
import {teaserTextBlock} from './modules/teaser-text-block';
import {contentLoadingAnimation} from './modules/content-loading-animation';
import {parallax} from './modules/parallax';


// Utils
// ---------------------------------

ieFix();
iosVhFix();

// Modules
// ---------------------------------

initModals();
menuTabs();
mobileMenu();
siteSearch();
cssVariables();
donateFaq();
donateButtons();
setInputMask();
readMore();
receptionPointsTabs();
viewAll();
readAll();
specialSlider();
helpNowSlider();
promoSlider();
bookmarkTransition();
contentLoadingAnimation();
createCustomSelect();
teaserTextBlock();
parallax();
